import React, { Component } from 'react';
import { Card, Button, message } from 'antd';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import Configuration from '../Configuration';
import Logo from '../images/visitapp-logo.png';

class Login extends Component {
  constructor() {
    super();
    this.state = {username: '', password: '', subdomain: 'serviacero', redirect: false, redirectUrl: '/'};
    this.handleUser = this.handleUser.bind(this);
    this.handlePassword = this.handlePassword.bind(this);
    this.handleCompany = this.handleCompany.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  handleUser(event) {
    let username = event.target.value.toLowerCase();
    username = username.trim();
    this.setState({username: username});
  }

  handlePassword(event) {
    this.setState({password: event.target.value});
  }

  handleCompany(event) {
    this.setState({subdomain: event.target.value});
  }

  handleLogin() {
    if(this.validate(this.state)) {
      const sendData = {user: {username: this.state.username, password_hash: this.state.password, subdomain: this.state.subdomain, id_devise: 'web', origin: 'web'}};

      axios.post(`${Configuration.apiServer}/api/v1/login`, sendData).then(resp => {
        if(resp.status !== 200) {
          return message.warning('Hubo un error al procesar tus credenciales');
        }
        
        if(resp.data.status === 'error') {
          return message.warning('Usuario o contraseña invalida');
        }

        // Save localstorage
        localStorage.setItem('visitapp:token', resp.data.token);
        localStorage.setItem('visitapp:id', resp.data.user.profile.id);
        localStorage.setItem('visitapp:names', resp.data.user.profile.names);
        localStorage.setItem('visitapp:branch_id', resp.data.user.profile.branch.id);
        localStorage.setItem('visitapp:branch_name', resp.data.user.profile.branch.name);
        localStorage.setItem('visitapp:company', resp.data.user.profile.company);
        localStorage.setItem('visitapp:rol', resp.data.user.profile.rol.name);
        // Update redirection props
        const redirectTo = Configuration.redirectUrl(resp.data.user.profile.rol.name);
        this.setState({redirectUrl: redirectTo, redirect: true});
      });
    } else {
      message.warning('Todos los campos son obligatorios');
    }
  }

  validate(fields) {
    let pass = true;

    for(let field in fields) {
      if(field !== undefined && fields[field].length < 1) {
        pass = false;
      }
    }

    return pass;
  }

  render() {
    // Login redirect
    if(this.state.redirect) {
      return (
        <Redirect to={this.state.redirectUrl} />
      );
    }

    // Render component
    return(
      <div style={{ background: '#f1f1f1', height: '100vh' }}>
        <div className="d-flex justify-content-center align-items-center" style={{ height: '90vh' }}>
          <Card className="login-content" style={{minWidth: '40%'}}>
            <div className="d-flex justify-content-center">
              <img src={Logo} height="60" alt="Visitapp industrial" style={{ margin: '30px 0px' }} />
            </div>
            
            <hr/>
            
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Usuario" onChange={this.handleUser} />
            </div>
            
            <div className="form-group">
              <input type="password" className="form-control" placeholder="******" onChange={this.handlePassword} />
            </div>
            
            <hr/>
            
            <div className="form-group text-center">
              <Button type="primary btn-block" onClick={this.handleLogin}>Acceder</Button>
            </div>
            <div className="form-group text-center">
              <Button type="dashed btn-block" style={{ marginRight: '10px' }}>Olvide mi contraseña</Button>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.js